import { uploadTemporaryFileRemote } from '@flex-apis/recruiting';
import { useMutationFromRemote } from '@flex-packages/remote-hooks';

function useUploadTemporaryFileRemoteMutation(options, paramsTransformer) {
  return useMutationFromRemote({
    remote: uploadTemporaryFileRemote,
    options,
    paramsTransformer
  });
}

export { useUploadTemporaryFileRemoteMutation };
//# sourceMappingURL=useUploadTemporaryFileRemoteMutation.mjs.map
